import React from 'react';

const CustomFieldContext = React.createContext('custom_field');

export default CustomFieldContext;
